import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import HaloSecurityConfigListing from "./HaloSecurityConfigListing";
import HaloSecurityCredentialsForm from "./HaloSecurityCredentialsForm";

export default function HaloSecurityPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={HaloSecurityCredentialsForm}
      PullConfigListingView={HaloSecurityConfigListing}
    />
  );
}
